import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, OutlinedInput, InputLabel } from '@material-ui/core';
import autoPayBg from '../../assets/QuickPay/autoPayBg.svg'
import capBg from '../../assets/capBg.svg';

export const useStyles = makeStyles((theme) => ({
 
  mainRoot: {
    width: '100%',
    backgroundColor: '#ccc',
    backgroundPosition: "bottom left",
    backgroundRepeat: "no-repeat",
    backgroundSize: 'contain',
  },

  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '2.4em 1.6em 9em',
    fontFamily: 'Montserrat',
    width: '100%',
    maxWidth: '122em',
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      padding: '2.4em 1.6em 5em',
    },
  },

  heading: {
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '400',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 14,
    textAlign: 'center'
  },

  pageHeading: {
    color: '#1A4664',
    fontFamily: 'Montserrat',
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 25,
    marginTop: 24,
  },

  formContainer: {
    width: '134em',
    minWidth: "33.3em",
    padding: '2.4em 3.4% 9.8em',
    backgroundColor: '#fff',
    borderRadius: 12,
    marginBottom: '6.6em',
    boxShadow: '0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '20px'
    },
  },

  stepperContainer: {
    backgroundColor: '#198100',
    marginBottom: 12
  },

  benefitsContainer: {
    margin: '0px 56px',
    padding: '2.4em 2.4em',
    backgroundColor: '#fff',
    borderRadius: 12,
    marginTop: 4,
    marginBottom: 20,
    border: '1px solid #B4B4B4',
    [theme.breakpoints.down('sm')]: {
      margin: '0px'
    },
  },

  onlinePaymentBenefits: {
    color: "#235A86",
    fontFamily: "Montserrat",
    fontSize: 24,
    fontWeight: "600",
    lineHeight: '28px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20
    },
  },

  stepperTitle: {
    color: "#FFFFFF",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "600",
    textAlign: 'center'
  },

  benefitTitle: {
    color: "#000000",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  fieldsMandatory: {
    color: "#000000",
    fontFamily: "Montserrat",
    fontSize: 20,
    fontWeight: "400",
    marginBottom: 14
  },
  
  checkmark: {
    width: '24px',
    height: '24px'
  },

  stepperLogo1: {
    width: '76px',
    height: '72px'
  },

  stepperLogo2: {
    width: '76px',
    height: '72px',
    marginLeft: 20
  },

  stepperLine: {
    margin: '34px 0px 0px 14px',
    border: '1px solid #F7B15C'
  },

  line: {
    margin: '12px 0px 20px 0px',
    border: '1px solid #f7b15c47'
  },

  orLine: {
    borderLeft: '1px solid #4d4d4d38',
    height: '80px',
    margin: 'auto'
  },

  orSection: {
    justifyContent: 'center',
    alignContent: 'center',
    display: 'grid'
  },

  or: {
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: '16px',
    fontWeight: '600',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 10,
    marginTop: 10
  },

  logo: {
    width: '100%',
    height: '218px'
  },

  mlw: {
    color: '#B4B4B4',
    fontFamily: 'Montserrat',
    fontSize: '26px',
    fontWeight: '700',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 16,
    marginTop: 14
  },

  benefits: {
    color: '#000000',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '400',
    letterSpacing: '0.18px',
    lineHeight: '24px',
    marginBottom: 6,
    marginTop: 12
  },
 
  signUpBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    height: 40,
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: '700',
    letterSpacing: '0.53px',
    borderColor: theme.palette.secondary.main,
    borderRadius: 4,
    textTransform: 'uppercase',
    padding: '10px 20px',
    outline: "none",
    cursor: 'pointer',
    textDecoration: "none",
    marginTop: 20,
    '&:hover': {
      backgroundColor:  theme.palette.secondary.main
    }
 },
 
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    fontSize: '3.6em',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 39,
    fontFamily: 'Montserrat',
    color: "#727272",
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.4em',
    },
  },

  inputContainer: {
    marginBottom: '3.9em',
  },

  tabContainer: {
    width: '100%',
    border: "2px solid",
    borderRadius: 4,
    padding: 5,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  activeTabBtn: {
    border: 'none',
    borderWidth: 0,
    width: '48%',
    borderRadius: 4,
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    fontWeight: "600",
    padding: 10,
    outline: "none",
    cursor: 'pointer',
  },

  tabBtn: {
    border: 'none',
    borderWidth: 0,
    borderRadius: 4,
    outline: "none",
    width: '48%',
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    fontWeight: 600,
    padding: 10,
    cursor: 'pointer',
  },
  radioBtn: {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Montserrat',
      fontSize: '16px',
    }
  },

  inputStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  labelStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
  },

  cancelBtn: {
    marginBottom: 20,
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    color: "#535D6D"
  },

  errorMsg: {
    fontSize: '1.4em',
    fontWeight: 'bold',
    textAlign: 'justify',
    marginBottom: 10,
    fontFamily: 'Montserrat',
    color: "red",
  },

  error: {
    fontSize: '1.2em',
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 5,
    fontFamily: 'Montserrat',
    color: "red",
  },

  captchaContainer: {
    //    
  },

  captchFieldContainer: {
    marginLeft: 30,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      marginTop: '3.9em'
    },
  },

  // captcha css
  refreshButton: {
    backgroundColor: 'rgb(37, 171, 199)',
    color: 'rgb(255,255,255)',
    cursor: 'pointer'
  },
  volumeButton: {
    backgroundColor: 'rgb(37, 171, 199)',
    color: 'rgb(255,255,255)',
    cursor: 'pointer'
  },
  captchaarea: {
    // backgroundImage: `url(${capBg})`,
    // backgroundSize: 'cover',
    // textAlign: 'center'
    border: '2px solid #D9D9D9',
    borderRadius: '6px'
  },
  captchasize: {
    fontSize: '38px',
    padding: '2px',
    margin: 0,
    fontFamily: 'cursive',
    fontWeight: '600'
  },
  buttonarea: {
    textAlign: 'right',
    paddingTop: '3px'
  },
  // end captch css

  //save loan number css
  tooltipTitle: {
    padding: '4px',
    fontSize: '15px',
    color: "#535D6D",
    fontWeight: '600',
    fontFamily: 'Montserrat',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },

  desc: {
    padding: '3px',
    fontSize: '14px',
    fontFamily: 'Montserrat',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },

  close: {
    float: 'right',
    fontSize: '26px',
    cursor: 'pointer',
    marginTop:'-18px',
    marginRight: '-px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
    },
  },

  saveLoanNumber: {
    color: '#4D4D4D',
    fontSize: 14,
    fontFamily: 'Montserrat',
    fontWeight: '400'
  },

  checkboxStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    paddingBottom: '3px',
    marginRight: 0,
    '& .MuiFormControlLabel-root': {
      marginRight: '0px'
    },
    '& .MuiSvgIcon-root': {
          fontSize: 16
    }
  },

  radioLabel: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: "600",
    cursor: 'pointer',
    color: '#535D6D',
    letterSpacing: '0.25px',
    lineHeight: '16px',
    '& .MuiRadio-colorSecondary.Mui-checked': {
      color: "#535D6D",
      fontWeight: "600",
    }
  },

  footerSection: {
    paddingTop: 35,
    paddingBottom: 30
  },

  cancelBtn: {
    width: 192,
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    float: "right",
    border: "2px solid",
    height: '40px',
    boxShadow: '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2)',
    borderColor: theme.palette.primary.main,
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
    },
  },

  saveBtn: {
    width: '192px',
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    marginLeft: 20,
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    height: '40px',
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
    },
  },

  homePageBtn: {
    width: '200px',
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    marginLeft: 20,
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    height: '40px',
    [theme.breakpoints.down('xs')]: {
      width: 'auto',
    },
  },


  //otp screen css

  emailSend: {
    color: "#198100",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "18px",
    marginBottom: 24
  },

  resendCode: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    fontWeight: "600",
    letterSpacing: "0.47px",
    display: 'block',
    textAlign: 'right',
    display: 'inline-block',
    paddingTop: 5,
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  disableResend: {
    color: '#B4B4B4',
    cursor: "none",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    fontWeight: "600",
    letterSpacing: "0.47px",
    display: 'block',
    textAlign: 'right',
    display: 'inline-block',
    paddingTop: 5,
    textDecoration: 'underline'
  },

  invalidCode: {
    fontSize: '1.4em',
    fontWeight: '600',
    textAlign: 'center',
    marginBottom: 20,
    fontFamily: 'Montserrat',
    color: "#E02020",
    letterSpacing: "0.47px",
    display: 'block',
    textAlign: 'right',
    display: 'inline-block',
    paddingTop: 5,
  },

  linkStyle: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: '1.4em',
    fontWeight: "600",
    letterSpacing: "0.47px",
    display: 'block',
    textAlign: 'right',
    display: 'inline-block',
    paddingTop: 5,
  },

  // Payment Screen
  refreshPage: {
    color: "#dd1e1eff",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  pageExpire: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  tokenTimer: {
    color: "#349259",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600"
  },

  loanNo: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    paddingTop: 4
  },

  welcome: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 22,
    fontWeight: '700'
  },

  account: {
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "400",
    paddingTop: 4
  },

  autoPayContainer: {
    width: '134em',
    minWidth: "33.3em",
    backgroundColor: '#fff',
    marginBottom: '6.6em',
    boxShadow: '0 1px 14px 7px rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.2)',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
  },

  autoPayBg: {
    width: '100%',
    backgroundImage: `url(${autoPayBg})`,
    backgroundRepeat: "no-repeat",
    minHeight: '22vh'
  },

  congratsBox: {
    margin: 'auto',
    display: 'block'
  },
 
  paymentDetailsContainer: {
    padding: '2.4em 3.6em 9em',
    [theme.breakpoints.down('sm')]: {
      padding: '2.4em 1em 9em'
    },
  },

  paymentSuccess: {
    color:'#235A86',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '400',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
      lineHeight: '24px'
    },
  },

  dueDateOften: {
    color:'#fff',
    fontFamily: 'Montserrat',
    fontSize: 24,
    fontWeight: '500',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    textTransform: 'uppercase',
    paddingTop: 30
  },

  dueDateStayStep: {
    color:'#fff',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '500',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    paddingTop: 5
  },

  paymentAck: {
    color:'#4D4D4D',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '700',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    margin: '20px 0 10px 0',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 16
    },
  },

  requestId: {
    color:'#4D4D4D',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '700',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 16
    },
  },

  email: {
    color: '#198100',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '700',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14
    },
  },

  popupCode: {
    backgroundColor: '#e3ecf1',
    padding: 16,
    '& h5': {
      color: 'rgba(0,0,0,0.87)',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 600,
      letterSpacing: '0.53px',
      lineHeight: '19px',
      textAlign: 'center',
      marginBottom: 12
    }
  },


  item: {
    margin: 5,
    width: '25%',
  },

  itemText: {
    color: "4D4D4D",
    fontFamily: "Montserrat",
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '20px',
    padding: 6
  },

  itemSubText: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: '20px',
    fontWeight: '700',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    padding: 6,
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px'
    },
  },

  history: {
    color: '#000000',
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: '400',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    textAlign: 'center',
    margin: '40px 0px 20px 0px'
  },

  historyLink: {
    color: '#007FFF',
    textDecoration: 'underline'
  },

  processedPayment: {
    color: '#000000',
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    textAlign: 'center'
  },

  paymentAckFooterSection: {
    paddingTop: 30,
    display: 'flex',
    justifyContent: 'center'
  },

  autopayBtn: {
    fontFamily: "Montserrat",
    fontSize: '1.6em',
    marginLeft: 20,
    fontWeight: "600",
    letterSpacing: "0.53px",
    lineHeight: "19px",
    textAlign: "center",
    height: '40px',
    color: '#0067CF',
    backgroundColor: '#ffff',
    [theme.breakpoints.down('xs')]: {
      width: 'auto'
    },
  },

  // Session timeout
  session: {
    color:'#000000',
    fontFamily: 'Montserrat',
    fontSize: 36,
    fontWeight: '700',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    margin: '24px 0px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 28
    },
  },

  sessionExpired: {
    color:'#000000',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '400',
    letterSpacing: '0.53px',
    lineHeight: '32px',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: 16,
      lineHeight: '24px'
    },
  },

  validationMsg: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'Montserrat',
    color: "#B91717"
  },

  noteMsg: {
    fontSize: 12,
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: 10,
    fontFamily: 'Montserrat',
    color: "#B91717"
  },

  contactUs: {
    color: "#B91717",
    fontWeight: 600
  },

  top: {
    top: 220
  },
 
  alreadyRegistered: {
    fontSize: 16,
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: 20,
    fontFamily: 'Montserrat',
    color: "#121D22"
  },

  link: {
    color: "#121D22",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: "600",
    textDecoration: 'underline',
    cursor: 'pointer'
  },

  printBtnIcon: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: "600",
    cursor: 'pointer',
    color: '#535D6D',
    float: 'right',
    textDecoration: 'underline'
  },

  printIconStyle: {
    fill: "#535D6D", 
    fontSize: 26, 
    marginLeft: "5px"
  },

  spam: {
    color: "#535D6D",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: "600",
    letterSpacing: "0.47px",
    marginBottom: 20
  },

  emailBox: {
    display: 'flex',
    alignItems: 'center'
  },

  emailInfo: {
    color: '#535D6D',
    fontSize: '20px',
    marginLeft: 14
  },

  processedPaymentBk: {
    color: '#000000',
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: '400',
    letterSpacing: '0.15px',
    lineHeight: '24px',
    textAlign: 'center',
    marginTop: 30
  },

 }
));

export const CutomTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#25ABC7',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#25ABC7',
      },
    },
  },
})(TextField);

export const CutomOutlinedInput = withStyles({
  root: {
    "&$focused $notchedOutline": {
      border: `2px solid #25abc7`
    }
  },
  focused: {},
  notchedOutline: {}
})(OutlinedInput);

export const CustomInputLabel = withStyles({
  root: {
    "&$focused": {
      color: "#25abc7",
    }
  },
  focused: {},
})(InputLabel);